<div class="relative w-full max-w-2xl mx-auto input-wrapper">
  <mat-form-field appearance="outline" class="w-full glass-form-field no-subscript">
    <input
      matInput
      [type]="type()"
      [value]="value()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      (input)="onInput($event)"
      [attr.aria-label]="placeholder()"
    />
    <button
      matSuffix
      mat-icon-button
      class="send-btn flex items-center justify-center rounded-full transition-transform active:scale-90"
      [attr.aria-label]="'common.send' | transloco"
      [disabled]="disabled()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    </button>
  </mat-form-field>
</div>

